import { handleActions } from 'redux-actions';
import { SELECT_MID, SETUP_MID, CLEAR_SELECTED_MID } from '../constants';

const init = {};

export default handleActions(
  {
    [SELECT_MID]: (state, { error, payload }) => {
      if (error) {
        return state;
      }

      return {
        ...state,
        hasSelectedMid: true,
        mid: payload.mid,
      };
    },
    [SETUP_MID]: (state, { error, payload }) => {
      if (error) {
        return state;
      }

      return {
        ...state,
        hasSelectedMid: true,
        mid: undefined,
      };
    },
    [CLEAR_SELECTED_MID]: (state, { error, payload }) => {
      if (error) {
        return state;
      }

      return {
        ...state,
        mid: undefined,
      };
    },
  },
  init,
);
